<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre9">Erster Akt</h3>
<p class="stage">Ein Gemach auf dem Bischofsberge, einem
altertümlichen Landhause, in Weinbergen und Gärten an der Saale
gelegen. Die Hinterwand zeigt in einer tiefen Nische der dicken
Mauer ein breites Fenster mit Bleifassungen. Durch das Fenster, das
offensteht, erblickt man Türme und Dächer einer alten Stadt am
jenseitigen Talabhange. Es ist Naumburg. Die Nische enthält zu
beiden Seiten altes Gestühl, auf stufenartiger Erhöhung aus
demselben Sandstein, der den Fußboden bildet; dazwischen steht ein
Spinnrad. Die Decke des Zimmers ist gewölbt. Aus ihrer Mitte herab
hängt ein schöner Hängeleuchter aus Messing, mit Lichtern, über
einem großen, runden und schweren Eichentisch. Mit einem schwarzen,
goldgesäumten Samt bedeckt, trägt dieser Tisch einige alte silberne
Gefäße und einen vergoldeten, gebuckelten Pokal. Die Wand links
schmückt ein alter Kamin. Zu seinen beiden Seiten sehr alte,
nachgedunkelte Bilder, Bischöfe im Ornat darstellend. Die Wand
gegenüber zeigt einen mächtigen Renaissanceschrank. Kleine
Rundpforten sind hinter dem Kamin und rechts vor dem Schrank.</p>
<p class="stage">Es ist gegen Mittag eines Tages Anfang
Oktober.</p>
<p class="stage">Auf zwei hochlehnigen Stühlen einander gegenüber
sitzen der alte Herr Ruschewey im ländlichen Hausanzug und ein
fremder ältlicher Herr, der Hut, Regenschirm und Überzieher auf dem
Schoße liegen hat. Ruschewey ist gebräunt, bärtig, frisch und
jovial. Der Herr, von nicht sehr einnehmendem Äußeren, bebrillt und
in Gummischuhen, hat den Typus des Stubengelehrten.</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Ja, ja! Erlauben Sie
mir, daß ich mir mittlerweile meine Pfeife anstecke?</p>
<p class="calibre1"><span class="speaker">Der Herr</span>. Oh, ich habe nichts zu
erlauben, Herr Ruschewey. Ich bin nur gekommen in aller
Bescheidenheit . . . ich wollte mich nur in aller Bescheidenheit
nach dem Befinden der jungen Damen untertänigst erkundigen, denen,
wie ich zu meinem Schmerze gelesen habe, das unerbittliche Fatum
Mutter und Vater so früh entrissen hat. Geht es den jungen Damen
einigermaßen zufriedenstellend, wenn ich fragen darf? Natürlich den
Umständen angemessen?</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Jawohl, ja! Es geht
meinen Nichten recht leidlich.</p>
<p class="calibre1"><span class="speaker">Der Herr</span>. Ja, ja, es war ein recht
schwerer Schlag. So schnell nacheinander Mutter und Vater. –
<a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page8" title="987/Pirki"></a></p>
<p class="calibre1"><span class="speaker">Ruschewey.</span> Jawohl, ja! Das heißt:
In welchem Blatt steht denn das? Meine arme Schwägerin, die ja
allerdings wirklich zu gut für diese Erde gewesen ist, hat unser
himmlischer Vater nämlich bereits vor fünfzehn Jahren zu sich
genommen. Volle vierzehn Jahre hat Bruder Bertold sie überlebt. Ich
fürchtete damals, er würde es nicht sechs Monate aushalten. Wo
haben Sie eigentlich meinen Bruder kennengelernt?</p>
<p class="calibre1"><span class="speaker">Der Herr.</span> Seltsamerweise in einem
Antiquitätenladen zu Amsterdam. Ich kann mich noch recht genau
erinnern. Es war in einer recht wenig für die Anknüpfung
gesellschaftlicher Beziehungen geeigneten Gegend der Judenstadt.
Aber Herr Ruschewey, wie er mir sagte, kam schon zum dritten Male,
und zwar einer alten Geige wegen, die der jüdische Antiquar
besaß.</p>
<p class="calibre1"><span class="speaker">Ruschewey</span> <span class="regie">(erhebt sich und öffnet den Schrank)</span>. Er hat sie
bekommen, die alte Geige; hier ist sie, wenn es Sie interessiert.
<span class="regie">(Er nimmt einen geschlossenen Geigenkasten aus
dem Schrank und stellt ihn auf den Tisch.)</span> Aber das ist
schon sehr lange her, daß Bertold diese Geige gekauft hat.</p>
<p class="calibre1"><span class="speaker">Der Herr.</span> Im Kriegsjahre
einundsiebzig war's. Ihr Herr Bruder war ein sehr lustiger Herr und
brachte den Juden oft zum Lachen; doch einig wurden sie lange
nicht.</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Ich weiß, es lag ihm
sehr viel daran. Er hatte sich nämlich in den Kopf gesetzt, daß
diese Geige dieselbe wäre, die vor sehr vielen Jahrzehnten einmal
meinem seligen Vater gestohlen wurde. Unser seliger Vater war
Organist, und zwar drüben am alten Naumburger Dome; der hatte
wieder das Instrument irgendwo, wer weiß, in der Sakristei oder
Glockenstube oder sonstigem Heiligtume für Motten, Schaben und
Würmer im Dome, und zwar in einzelnen Stücken, gefunden.
<span class="regie">(Er hat den Kasten geöffnet, die Seidentücher
behutsam vom Geigenkörper zurückgeschlagen.)</span> Nur um's
Himmels willen, daß Lux nicht kommt; sonst nimmt sie den Onkel bei
den Ohren.</p>
<p class="calibre1"><span class="speaker">Der Herr</span>. Gewiß gehört es der
jungen Dame.</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Gewiß gehört's ihr, und
zwar mit Recht: denn der andere Grund, weshalb er die Geige
ankaufte, war, daß Lux als sechs- oder siebenjähriges kleines Ding
immer ein Liedchen sang, das die Worte enthielt: »Eine kleine Geige
möcht' ich haben.« Sie hat auch seitdem recht wacker den Bogen
führen gelernt. <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page9" title="987/woldemar"></a></p>
<p class="calibre1"><span class="speaker">Der Herr</span>. Das Fräulein Lux ist die
wievielte?</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Das Nestküken. Übrigens
flügge genug!</p>
<p class="calibre1"><span class="speaker">Der Herr</span>. Darf ich mir nun die
Frage erlauben, wenn es nicht unbescheiden ist: Wird man die Damen,
und wäre es für einen noch so kurzen köstlichen Augenblick, zu
Gesicht bekommen?</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Ich glaube nicht.</p>
<p class="calibre1"><span class="speaker">Der Herr</span>. Auch nicht, wenn man in
der Lage ist, ihnen dies und das aus Persönlichem von der Begegnung
mit ihrem Herrn Vater zu berichten?</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Weiß der Deubel, die
Mädels sind scheuer als Holztauben.</p>
<p class="calibre1"><span class="speaker">Der Herr</span>. Ja, das hat man mir schon
im Gasthause drüben in Naumburg gesagt, als ich mich nach der
Besitzung erkundigte. Ich muß gestehen, es tut mir leid. – Ich
hoffe, Sie nehmen es, wie es gemeint ist, wenn ich Ihnen mitteile –
wir sind ja unter uns Männern, nicht? –, daß ich wohlsituiert,
nicht ohne private Mittel, Junggeselle und überdies ordentlicher
Professor für klassische Philologie in Dorpat bin. Sie nehmen es
mir gewiß nicht übel?</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Alle Achtung! Wie käme
ich denn dazu!</p>
<p class="calibre1"><span class="speaker">Der Herr</span>. Alle Achtung. Besonders,
wenn man alles, wie ich als Kind armer Leute, durch eisernen,
rastlosen Fleiß sich mühsam errungen hat. Ja. – Also: – »Wenn Sie
Professor sind« – richtig! sagte der arme Herr Ruschewey damals zu
mir in Amsterdam, als wir so stillvergnügt miteinander die
portugiesische Synagoge betrachteten –, »wenn Sie Professor
sind, kommen Sie zu mir! Ich hab' eine hübsche Fasanerie«, setzte
er noch mit Humor hinzu. »Sie wird Ihnen möglicherweise Spaß
machen.« – Den Augenblick habe ich leider verpaßt; denn als ich
Professor geworden war . . .</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Wenn es Ihnen recht ist,
Herr Professor, so gehen wir jetzt in den Garten hinaus, und ich
lasse Sie gleich durch das untere Pförtchen. Sie gehen doch oben
beträchtlich um.</p>
<p class="calibre1"><span class="speaker">Der Herr</span>. Ich bin Ihnen äußerst
verbunden dafür. – Das heißt, ehe ich gehe, noch ein Wort. – Ich
habe die weite Reise gemacht . . . ich bin auch nicht mehr der
Allerjüngste . . . Würde es vollkommen nutzlos sein . . . wir sind
unter uns, unter Ehrenmännern! . . . mir schwebte, ich sage es frei
heraus, die ältere von den Damen vor: ich benötige jemand <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page10" title="987/woldemar"></a> gesetzteren
Alters! . . . würde es nun ganz nutzlos sein, wenn ich fernerhin
Zeit und Mühe dransetzte . . .</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Vollkommen nutzlos, ganz
unbedingt.</p>
<p class="stage">Man hört flüchtige Rufe und plötzlich frisches,
glockenartiges Gelächter von Mädchenstimmen.</p>
<p class="calibre1"><span class="speaker">Der Herr</span> <span class="regie">(hat
sich erhoben und eine Verbeugung gemacht)</span>. Verzeihen Sie
gütigst, wenn ich gestört habe. – Es ist ein beschwerlicher Weg
hierherauf.</p>
<p class="calibre1"><span class="speaker">Ruschewey</span>. Auf runterzu geht es
bedeutend leichter.</p>
<p class="stage">Er öffnet das Pförtchen, läßt den Herrn
vorantreten und geht mit ihm ab.</p>
<p class="stage">Ludowike Ruschewey, ein schlankes fünfzehnjähriges
Mädchen mit kleinem Kopf, kommt leichtfüßig durch die Tür neben dem
Kamin. Als sie die Geige auf dem Tisch bemerkt, erschrickt sie und
entrüstet sich dann.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Was bedeutet denn das?
Wer hat denn, gelinde gesagt, die Kühnheit besessen und hat meine
Violine herausgeholt? <span class="regie">(Sie nimmt das Instrument
heraus, betrachtet es und legt es zurück. Nun kommt durch die
gleiche Tür wie sie Adelheid herein. Ludowike ruft ihr
entgegen.)</span> Hast du meine Geige in Händen gehabt?</p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(die
ein gereiftes und schönes Mädchen ist, mit ausdrucksvollem Gesicht
und fast südlichem Temperament und Feuer, antwortet
leichthin)</span>. Aber, Dummchen, wie kommst du darauf? Tritt
übrigens mal hinter den Vorhang. Onkel lotst wieder mal einen
hinaus. <span class="regie">(Sie späht, hinter dem Vorhang
versteckt, durchs Fenster.)</span></p>
<p class="calibre1"><span class="speaker">Ludowike</span> <span class="regie">(stellt sich sogleich neben die Schwester)</span>.
O Gott, wie aus dem Beinhaus entsprungen! Ein Gesicht wie'n
alter Schweinslederband!</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Beinah wie'n Bruder von
Ewald Nast; oder find'st du den hübscher?</p>
<p class="calibre1"><span class="speaker">Ludowike</span> <span class="regie">(sich
schüttelnd)</span>. Brrr, Adelheid, bitte, verschone mich!
<span class="regie">(Sie begibt sich wieder an ihre Geige, schließt
den Kasten und stellt ihn in den Schrank.)</span></p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Willst du nicht gleich
etwas üben, mein Liebchen?</p>
<p class="calibre1"><span class="speaker">Ludowike</span> <span class="regie">(eine
priesterlich segnende Gebärde flüchtig nachahmend.)</span> Du
auserwählete Jungfrau: nein!</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Ja, mein liebes Kind,
warum denn nicht? Du hast noch ein hübsches Weilchen zu warten.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Offen gesagt, eure
Errungenschaften und Aussichten blenden mich eigentlich nicht; wie
wirst du <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page11" title="987/Pirki"></a>
heißen? Nicht mal Frau von Kranz, bloß Frau Kranz wirst du heißen!
Ruschewey klingt doch zehnmal so gut, und wir haben außerdem einen
Stammbaum. Ganz hübsch sah zum Beispiel der Rittmeister aus, als
die Leutnants neulich zu Pferde herauskamen! – Aber Agathe ist doch
blind! die sieht doch die schönsten Beine nicht. Bleibt also ihr
Pädagoge Ewald: eh ich den nähme, würde ich Nähterin.</p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(drollig betroffen)</span>. Seh' einer bloß dies Küken an!
– Ich werde dir nochmals Konfekt mitbringen.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Jetzt sage mal ehrlich,
Adelheid: was soll ich eigentlich davon haben, daß du dich zum
Beispiel nächstens verheiratest? Na ja; auf der Hochzeit werde ich
tanzen! Aber nachher, gleich, da verliert man dich doch! Oder sieh
mal Agathe an . . . früher war sie gesellig und heiter – seit sie
verlobt ist, ist sie meistens verstört und menschenscheu.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Ist sie denn überhaupt
verlobt?</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Ja, würde denn Ewald sie
sonst so martern? Das müßt ihr doch sehen, er martert sie doch! Er
macht sie doch reinwegs krank und schwermütig. Was gehen mich denn
eure Bräutigams an, wenn sie einem Geschwister abspenstig machen!
Ihr tut einem einfach ganz schauderhaft leid: ihr tut ja doch
keinen Atemzug, den sie euch nicht genehmigt haben! Und früher, da
wart ihr frei wie der Wind.</p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(knicksend)</span>. Au contraire! Erst jetzt ist man frei
geworden.</p>
<p class="stage">Die Tür neben dem Schrank wird hinter dem Rücken
der Mädchen vorsichtig geöffnet, und ein Mann mit zerlaufenen
Schuhen, geflickten Sachen, Knotenstock und verwegenem Kalabreser
tritt ein. Er hat eine grobe Ledertasche umgehängt. Sein
ziegenbockartiges Gesicht ist mit Sommersprossen bedeckt, übrigens
nicht uninteressant. Haupt- und Barthaar rötlich. Das Alter des
Vagabunden kann etwa fünfunddreißig Jahre betragen.</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. Ich möchte mir eine
Frage erlauben.</p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(fährt
erschrocken herum)</span>. Um Gottes willen! Was wollen Sie
denn?</p>
<p class="stage">Ludowike ist nach der Klingelschnur gelaufen und
hat sie heftig gezogen.</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. Bei Gott, meine
Damen, ich will weiter nischt. Ich mechte mir bloß die Frage
erlauben: Wo geht denn der Weg nach Merseburg? <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page12" title="987/Pirki"></a></p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Wie sind Sie denn hier
hereingekommen?</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. Auf Ehre, das weiß
ich alleene nich! Erschtlich bin ich durch Gestrippe gestiegen,
dann bin ich durch einen Weinberg runtergekomm'n, dann auf einen
breiten Gartenweg, dann in eine scheene Eintrittshalle, dann durch
einen scheenen Speisesaal, dann über ein kleines Treppchen rauf,
und nu mechte ich gerne in meine Heimat.</p>
<p class="stage">Adelheid und Ludowike blicken bald den seltsamen
Eindringling, bald einander an und brechen schließlich in
herzhaftes Lachen aus.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Wo ist Ihre Heimat
eigentlich? Doch nicht etwa vielleicht unsere Speisekammer!</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. Nein. Usingen ist
mein Heimatland.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Hast du den Namen schon
jemals gehört, Lux?</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Non, mon enfant.</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. Ce n'est rien que
Silésie, mesdames.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Sie sprechen
Französisch?</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. C'est ça. Ich bin ein
Jahr lang in Algier gewesen: ich war nämlich Fremdenlegionär! Dann
hab' ich mich aber kleene gemacht.</p>
<p class="calibre1"><span class="speaker">Ludowike</span> <span class="regie">(ruft
durchs Fenster hinunter)</span>. Da ist Otto! Otto, komm doch mal
rauf! Wir haben Besuch aus Algier bekommen.</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. Ich kann Ihn'n meine
Papiere zeigen. Uff Parole d'honneur; ich beschwindle Ihn'n nich.
<span class="regie">(Er kramt in seiner Tasche herum, die er ohne
Umstände auf den Tisch legt.)</span></p>
<p class="stage">Durch die Tür an der Kaminwand tritt der
siebzehnjährige Otto Kranz, ein Bruder von Adelheids Bräutigam. Er
trägt sich idealisch, mit Schnallenschuhen, fliegenden
Krawattenenden und langem Haar.</p>
<p class="calibre1"><span class="speaker">Ludowike</span> <span class="regie">(übermütig)</span>. Erlauben die Herren, daß ich vorstelle:
Herr Otto Kranz, sculpteur de talent de Munic, und . . .?</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. Ich bin ein geborener
Klemt! <span class="regie">(Nach gravitätischer Verbeugung.)</span>
Und nu darf ich vielleicht zur Sache kommen. Das ist doch hier
nämlich ein altes Haus. Das hab' ich nämlich von weitem gesehen,
wie das mit dem hohen Dache so hoch aus a Linden und aus a
Kastanien und aus a Nußbäumen rausgucken tutt, daß das hier a alter
Kasten sein muß. Und solche Geniste, die sein was für mich: von
Beruf bin ich nämlich Kammerjäger. <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page13" title="987/Pirki"></a></p>
<p class="calibre1"><span class="speaker">Otto</span> <span class="regie">(ohne
weiteres laut)</span>. Wie hat sich der Kerl denn hier
eingeschlichen?</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. Kerl? I nee, weeß
Kneppchen. Da irren Sie sich! Ich geh' Ihn'n meinem Gewerbe nach,
wie ein Jagdhund, Sie, wie ein richtiger Finder. Und da find' ich
ooch stets was und täusche mich nich.</p>
<p class="calibre1"><span class="speaker">Otto</span>. Ihr Gewerbe dürfte das
Schnorren sein! – Kommen Sie mit! – Ich werde ihn raussetzen.</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. Und Ratten und Mäuse
hätten Se nich? Und Kreuzottern keene in Ihrem Weinberg? Und
Schlüffel nich? Und o Schwaben nich? Kee Ungeziefer im ganzen
Hause? O keene schwarzen Husaren, mesdames?</p>
<p class="calibre1"><span class="speaker">Otto</span>. Es ist bloß ein Hund hier,
der Schweizer heißt! Ein ziemlich bissiger Bernhardiner.</p>
<p class="calibre1"><span class="speaker">Der Vagabund</span>. De Schweizer sein
gude Suldaten. Jawohl! – Also nischt nich fer ungutt! C'est ça,
mesdames. <span class="regie">(Er geht, von Otto eskortiert; an der
Tür wendet er sich nochmals und blinzelt pfiffig nach den
vergoldeten Gefäßen hin, die den Tisch schmücken.)</span> Scheene
Goldschmiedearbeit hab'n Se da stehn! Da lacht einem alten
Schnapphahn das Herze! <span class="regie">(Gefolgt von Otto,
ab.)</span></p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(ironisch)</span>. Otto ist heut gar nicht bei Humor. Ich
dachte, der Mensch müßte ihm doch Spaß machen.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Ich hab' ihn beim
»Arbeiten« aufgestört. Er zeichnete oder schrieb Gedichte. – Macht
dein Bräutigam denn auch Gedichte?</p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(ironisch)</span>. Leider nein! Otto hält sich für das
Genie der Familie!</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Dann hätte ich doch Otto
genommen.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Das Kind?</p>
<p class="stage">Ludowike, im Begriff davonzueilen, trifft in der
Tür auf Otto und Sabine.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Habt ihr gesehen? Der
wollte mich! Wie steh' ich da: wieder ein neuer Antrag! Schon vier
Anträge hat Onkelchen mir verpfuscht! Nächstens werd' ich ihm mal
gründlich das Ohrläppchen kneipen! <span class="regie">(Heiterkeit.)</span> Wißt ihr nicht, wo Agathe ist? – Otto,
hat sie dir nicht heut morgen gesessen?</p>
<p class="calibre1"><span class="speaker">Otto</span>. Ja. Ich habe bis etwa vor
einer halben Stunde unten im Winzerhaus modelliert; dann plötzlich,
ich weiß nicht, kam der Briefträger, und da stand sie plötzlich auf
und verschwand. <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page14" title="MEsswein/Pirki"></a></p>
<p class="calibre1"><span class="speaker">Sabine</span>. Ich habe sie mindestens
eine halbe Stunde lang im Garten gesucht.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Gib Geld, Sabine, es sind
wieder Sendungen.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Du, deine Ausstattung macht
uns bankerott.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Dann erben wir wieder von
Großmama.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Möglicherweise ist Ewald
gekommen, und sie muß ihm wieder irgendeinen albernen
Verschönerungsvereins-Jahresbericht oder sonst was ins reine
schreiben. Oder Vermögenssachen von Tante Emilie, die er doch ganz
in den Klauen hat.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Pfui, Lux, wer wird von
Klauen reden! Vor zwölf kommt er übrigens nicht heraus; denn bis
elf Uhr dauert sein Unterricht. <span class="regie">(Halblaut zu
Adelheid.)</span> Ich muß dir mal etwas leise sagen.</p>
<p class="calibre1"><span class="speaker">Otto</span>. O bitte, laut, ich störe euch
nicht. <span class="regie">(Er geht ab.)</span></p>
<p class="calibre1"><span class="speaker">Sabine</span>. Otto! Warum denn? Bleib
doch gefälligst.</p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(neugierig)</span>. Laß ihn doch ruhig. Das schadet ihm
nichts. – Was gibt's denn?</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Nichts, als daß Dr.
Grünwald im Schwarzen Roß zu Naumburg ist mit seinem alten Freund
Kozakiewicz.</p>
<p class="calibre1"><span class="speaker">Ludowike</span> <span class="regie">(die
sich neugierig herangeschlichen hat.)</span> – Wer?</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Papperlapapp, du
Kiekindiewelt!</p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(in
höchstem Erstaunen)</span>. Aber nein, Sabine, das glaube ich dir
nicht.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Ja nun, das wird die Sache
nicht ändern. Erkundige dich doch mal beim Onkel darum.
<span class="regie">(Sie kniet, schließt ein Schrankfach auf und
kramt darin.)</span></p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(händeringend, in einer Art humoristischer
Verzweiflung)</span>. Aber, Mädels, um Gottes und Christi willen:
was wird denn jetzt bloß Agathe tun?</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Was ist denn das nun für
eine Geschichte?</p>
<p class="calibre1"><span class="speaker">Adelheid</span> <span class="regie">(zu
Sabine mit Bezug auf Agathe)</span>. Weiß sie es schon? Ich denke
doch nicht. Wenigstens läßt sie sich nichts merken.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. I, da muß eben wieder
Onkelchen einspringen. Die Sache ist eben doch abgetan.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Leutchen, wenn ihr so
weiter in Rätseln sprecht, dann bin ich ja eigentlich
überflüssig.</p>
<p class="calibre1"><span class="speaker">Sabine</span> <span class="regie">(lustig)</span>. Das bist du auch. Immer marsch, fort mit
dir.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Gerade nicht! Ich bin alt
genug! Und wenn ihr wollt meine Schwestern sein, so habt ihr vor
mir auch keine Geheimnisse. <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page15" title="987/Pirki"></a></p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Sabine, das glaub' ich
dir nimmermehr: das ist wieder einer deiner Scherze. Der ist ja
doch in Amerika, wer weiß wo, untergetaucht und verschollen.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Na, und jetzt ist er eben
zurück und sitzt fuchsmunter im Roß zu Naumburg.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Wenn ihr denkt, daß ich
die Geschichte nicht weiß, so seid ihr doch recht sehr
schiefgewickelt.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Dummchen, was für 'ne
Geschichte denn?</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Warum war denn Agathe
immer so schwermütig? Weil sie keinen Brief mehr von ihm bekam!</p>
<p class="calibre1"><span class="speaker">Sabine</span> <span class="regie">(leichthin)</span>. Von wem denn?</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Na, von dem
Amerikaner.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Du hast was läuten hören,
mein Kind.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Und dann hat sie aus Wut
oder was weiß ich dem Schulmeister ihre Seele verkauft.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Pst, liebe Lux: sprich
keine Torheiten! Im Grunde geht uns das alles nichts an, und man
muß jedem sein Seelenheil selbst überlassen. Du bist übrigens
tatsächlich alt genug, und's ist besser – meinst du nicht auch,
Adelheid? –, du weißt, wie die Sachen wirklich sind! Du kannst
dann vielleicht Taktlosigkeiten vermeiden, statt daß du aus
Unwissenheit welche begehst. Agathens Empfindlichkeit ist ja fast
sprichwörtlich.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Also wirklich? Grünwald
ist drüben in Naumburg?</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Er hat bei Onkelchen
angefragt, ob sein Besuch uns genehm sein würde.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Und wenn er mit Ewald
zusammentrifft!</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Nun was? Es sind doch
gebildete Menschen.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Ich verstehe die Sache
noch immer nicht.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. So, nun zeige dich mal der
Sache gewachsen; Grünwald ist der gewesene Marinearzt, von dem du
sicher schon oft gehört hast. Papa jedenfalls sprach öfters von
ihm. Zwischen ihm und Agathe hat etwas geschwebt. Sie lernten sich
kennen auf Sylt im Seebad. In einem Sommer, du weißt es ja doch,
waren Papa, ich und Agathe in Westerland.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Vorsicht, daß uns Agathe
nicht hört.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Oder Ewald, er muß jeden
Augenblick kommen.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Sie waren also ganz
richtig verlobt?</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Verlobt und auch nicht.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Wie geht denn das?</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Eigentlich waren sie
versprochen, und andererseits waren sie auch wieder frei. <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page16" title="987/DaoH"></a></p>
<p class="calibre1"><span class="speaker">Sabine</span> <span class="regie">(indem
alle drei die Köpfe immer geheimnisvoller zusammenstecken)</span>.
Liebchen, hast du nicht manchmal bemerkt, daß Agathe gegen den
seligen Papa einen gewissen Groll in der Seele trägt?</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Du weißt ja, ich wurde
sogar mal heftig! Papas Andenken lass' ich mir einmal nicht
antasten.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Agathe tut das im Grunde
auch nicht. Aber Papa hat damals zu Grünwald gesagt, er solle sich
noch zwei, drei Jahre herumtummeln und dann werde es Zeit zu der
Frage sein, die er ihm jetzt nicht beantworten könnte.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. O weh, lieber Papa, da
ging' ich durch!</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Und jetzt kannst du dir
wohl auch einen Begriff machen, was Agathe inzwischen gelitten hat.
Briefe hatte Papa verboten. Mündlich hatten die beiden abgemacht:
ein Lebenszeichen nach Verlauf jedes Jahres!</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Er sollte schreiben!</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Er schrieb aber nicht.
Der Termin kam heran, und er blieb verschollen. Dann starb Papa,
und es rührte sich nichts. Dann kam ihre Krankheit und Ewalds
Werbungen und Tante Emiliens Apparat . . .</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Und nun wieder ist Grünwald
auf einmal da und, wer weiß, erscheint vielleicht auf der
Bildfläche.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. – Sabine, du hast doch
wohl Spaß gemacht.</p>
<p class="calibre1"><span class="speaker">Sabine</span> <span class="regie">(achselzuckend)</span>. Mit solchen Sachen ist nicht zu
spaßen! Denkt, was ihr wollt, bloß verschnappt euch nicht.</p>
<p class="stage">Oberlehrer Dr. Ewald Nast tritt ein. Er trägt
Gehrock, Zylinder und schwarze Krawatte, sehr blankes, aber plumpes
Schuhwerk. Die Kleider, von einem Provinzschneider gemacht, sind
lange getragen, aber gut gehalten. Nast hat einen Sommerüberzieher
überm linken Arm, in der gleichen Hand einen Schirm, in der rechten
den Zylinder, im Munde einen Zigarrenstummel.</p>
<p class="calibre1"><span class="speaker">Nast</span> <span class="regie">(laut und
selbstbewußt auftretend)</span>. Guten Morgen, ihr Mädchen, ein
prachtvoller Tag! – Ich komme vom Zahnarzt direktement! einen
Backenzahn, drei scheußliche Wurzeln! mich gehalten wie Mucius
Scaevola! Nur muß ich noch meinen Stummel ausrauchen. Tabak
bekanntlich desinfiziert. <span class="regie">(Scherzhaft zu
Ludowike.)</span> Nicht wahr, meine Gnädige?</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Und stinkt auch
bekanntlich.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Das kommt immer auf die
Zigarre an.</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Die Ihrige kostet ja wohl
sechs Pfennige. <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page17" title="987/lesdochmal"></a></p>
<p class="calibre1"><span class="speaker">Nast</span>. Cousin und Cousine: ich
erbitte das Du. Ich zweifle nicht, daß es bessere gibt! Nun, man
muß sich nach seiner Decke strecken. Wie geht's unsrer lieben
Agathe, gut?</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Ich habe sie heute noch
kaum gesprochen.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Nun, ich werde gleich selbst
zum Rechten sehn! Je mehr ich mich in die Sache hineindenke, je
mehr macht mir die kommende Hochzeit Spaß. – Die Schüler hatten
heut Klassenarbeit, und während ich auf dem Katheder saß, da hab'
ich mir etwas ausgesonnen, was dich, liebe Adelheid, freuen wird.
Ich meine an deinem Ehrenabend.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Ich lasse mich
überraschen, nur zu!</p>
<p class="calibre1"><span class="speaker">Nast</span>. Ist dein kleiner Schwager
eigentlich anstellig?</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Inwiefern, Ewald, soll er
denn anstellig sein?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Erstlich brauche ich jemand,
der mir mein kleines Versspiel ins reine bringt . . .</p>
<p class="calibre1"><span class="speaker">Ludowike</span>. Ihre Verse abschreiben?
Das tut Otto nicht. Dazu ist er zu stolz. Er macht selber
welche.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Oh! Messer, Gabel, Schere,
Licht ist für kleine Kinder nicht. Doch immerhin – lassen wir ihm
das Vergnügen, ein bißchen Herzen und Schmerzen zu reimen, wenn nur
niemand dabei beschädigt wird; auch macht mir Agathe schließlich
die Reinschrift, doch hätte ich etwas anderes für ihn.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Besprich es doch mit ihm
selber, Ewald.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Nur nicht in Adelheids
Gegenwart.</p>
<p class="calibre1"><span class="speaker">Adelheid</span>. Ich muß sowieso zu den
Weißnähterinnen. Ich habe drei Nähterinnen im Haus. Wenn ich Otto
sehe, will ich ihn reinschicken.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Vielleicht, daß er doch die
Gnade hat! <span class="regie">(Adelheid ab.)</span> Sonst nehme
ich einen meiner Quartaner. – Übrigens: Euren Gärtner solltet ihr
abschaffen.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Warum?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Weil er dreist und untüchtig
ist. Ich hatte eben mit ihm beinah ein Renkontre.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Onkel hält ziemliche Stücke
auf ihn.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Laissez aller: das ist Onkels
Grundsatz. Ich sage euch: schafft diesen Gärtner ab! Und ihr werdet
es tun, trotz des guten Onkels und seiner strafwürdigen
Bonhomie.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Was hat's denn gegeben mit
dem Gärtner?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Ich muß mich ein bißchen mit
Reden in acht nehmen. <span class="regie">(Er faßt nach der
Backe.)</span> Er benimmt sich gegen mich flegelhaft, und zwar bei
jeder Gelegenheit. Und dann begeht der Mensch gradezu Tollheiten.
<a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page18" title="vipi/woldemar"></a></p>
<p class="calibre1"><span class="speaker">Sabine</span>. Wieso?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Ich nenne es eine Tollheit,
Sabine, wenn er einen Burschen hier bei sich hat – ich meine in
eurem Garten beschäftigt –, ein Subjekt, das mehr als
verdächtig ist! Einen Kerl, der am gestrigen Nachmittag bereits
unser Naumburg unsicher machte, bis er schließlich auch meine zwei
Treppen erstieg, wo ich ihm aber gehörig den Text geigte. Mir sagte
der Mensch, er sei Scharfrichterknecht; – und hier läßt ihn der
Gärtner Maulwürfe wegfangen.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Ach, es sind ja doch Männer
im Haus, guter Ewald.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Wenn ihr töricht sein wollt,
ich dulde es nicht. Entweder der Onkel setzt ihn raus, oder ich
werde die Polizei verständigen. Am besten, der Gärtner fliegt
gleich mit; denn er betrügt euch, wenn ihr die Augen wegwendet.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Papa machte immer einen
bestimmten Abstrich auf Betrug.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Das konnte Papa, ihr dürft
das nicht. Das hieße ja unverantwortlich wirtschaften! Man wirft
doch das Geld nicht zum Fenster hinaus.</p>
<p class="calibre1"><span class="speaker">Ludowike</span> <span class="regie">(indem
sie, sich räkelnd, hinausgeht)</span>. Wenn man welches hat, warum
soll man's nicht rauswerfen. <span class="regie">(Ab.)</span></p>
<p class="calibre1"><span class="speaker">Nast</span>. Oh! oh! oh! oh! Der Tausend
noch mal! An Lux ist viel gesündigt worden! Es rächt sich, wo eine
strenge und konsequente Erziehung gebricht!</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Aber, Ewald, das sind doch
nur harmlose Unarten.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Ihr glaubt es mir nicht! Ihr
glaubt es mir nicht. Ihr laßt dem Kinde sträflich viel Freiheit.
Darin hat Tante Emilie vollkommen recht. Eines Tages, sag' ich
euch, muß es sich rächen.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Hu, hu! Das klingt aber
fürchterlich!</p>
<p class="calibre1"><span class="speaker">Nast</span>. Ihr glaubt, ihr seid niemand
verantwortlich, weil ihr unabhängig hier oben lebt. Ihr seid für
das Freie und Ungebundene; aber wenn ihr manchmal zu hören bekämt,
was drüben in Naumburg von euch gesagt wird, dann würdet ihr sehn,
daß die Welt nicht schläft und daß niemand so unabhängig ist, um
sich auch nur im geringsten Punkt ungestraft gegen sie zu
versündigen.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Ei! ei! ei! ei! Was
bedeutet denn das?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Liebste Muhme, wir wollen das
Kriegsbeil nicht ausgraben. Ich hoffe, du mißverstehst mich nicht.
Meine brave Agathe denkt ganz wie ich; und ich sehe den Tag in
nicht weiter Ferne, wo auch du, eigentlich der Verstand der
Familie, <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page19" title="987/woldemar"></a> auf
die mittlere Linie der Lebensführung zurückkommen wirst.
<span class="regie">(Otto tritt ein.)</span> Jetzt wollen wir uns
den Präliminarien froher Stunden widmen. – Sage doch mal, du junger
Adonis von sechzehn Lenzen! Ich hätte eine Sache für dich. – Du
wirst ja bleich: erschrick nur nicht. Du sollst ja nicht mensa
deklinieren! Es handelt sich nur um einen Scherz.</p>
<p class="calibre1"><span class="speaker">Otto</span>. Wäre ich dabei unbedingt
notwendig?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Niemand, mein Sohn, ist
unbedingt notwendig. Also hör mal, was ich eigentlich will. Du
weißt, was Scherz ist.</p>
<p class="calibre1"><span class="speaker">Otto</span>. Ich hoffe doch.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Ich auch. Also werden wir uns
bald einigen. – Ich habe nämlich ein Festspiel verfaßt, und in
diesem Festspiel sind nur zwei Rollen, und die dritte . . .</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Ich denke, es sind bloß
zwei?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Und die dritte, junger
Freund, sollst du darstellen. »Peter Squentz« von Gryphius kennst
du nicht . . . ich will lieber etwas weiter ausholen. Dieses Haus
hier hat früher zum Dom gehört. Eigentümerin war das Domkapitel,
und Domherren haben es früher bewohnt, Bischof Throta sogar,
Kirchenfürsten mitunter, und das Wappen, das sich am Kamin noch
vorfindet, trägt einen Palmesel, Stab und Bischofshut. Es handelt
sich aber nur um den Palmesel.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Soll Otto den Palmesel etwa
darstellen?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Die dritte, sehr lustige
Rolle ist stumm in der Tat und wäre allerdings quasi der
Palmesel.</p>
<p class="stage">Sabine stutzt einen Augenblick und bricht dann in
helles Gelächter aus. Nast seinerseits stutzt zunächst ebenfalls,
und zwar über das Gelächter, von dem fortgerissen er, allerdings
etwas gezwungen, schließlich mitlacht.</p>
<p class="calibre1"><span class="speaker">Otto</span> <span class="regie">(verbeißt
sichtlich den Ärger über die Verletzung seines Selbstgefühls und
sagt dann ruhig)</span>. Das Fach des Clowns, Herr Oberlehrer,
liegt mir nicht. Aber da ich Bildhauer bin, würde ich mich gern
anheischig machen, einen Palmesel nach dem Leben, sehr
porträtähnlich, zu modellieren. Wenn gebrüllt werden soll, macht
das ein Hausknecht vielleicht.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Ah, aha! Ist man der
jugendlichen Überhebung und Eitelkeit doch wieder einmal zu nahe
getreten. Es gibt heute keine Jugend mehr.</p>
<p class="calibre1"><span class="speaker">Otto</span>. Das liegt dann vielleicht an
ihren Erziehern.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Lassen wir das! Keine
Kontroversen! Es steht dir nicht! Und mir würde es nun schon gar
nicht geziemen, mit dir <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page20" title="987/woldemar"></a> um ernsthafte Fragen zu streiten. Das
Mißverhältnis wäre zu kraß.</p>
<p class="calibre1"><span class="speaker">Otto</span>. Weshalb duzen Sie mich denn
eigentlich?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Mein Freund, Ihnen fehlt die
Naivität. Denken Sie an die Fastnachtsspiele! Denke doch an den
Meister Hans Sachs! Denke doch an die alte Tierfabel, an den Weber
Zettel im »Sommernachtstraum«! Einen Esel naturgetreu darzustellen,
braucht einer durchaus kein Langohr zu sein.</p>
<p class="calibre1"><span class="speaker">Sabine</span>. Liebe Festgenossen in spe,
entzweit euch nicht. Es empfiehlt sich, bei gutem Humor zu bleiben;
denn ein guter Humor ist ja doch der Zweck.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Dieser Dummstolz, der keinen
Spaß versteht, Gespreiztheit! Unreife mit Prätentionen! Was mir
peinlicher wäre, wüßte ich nicht.</p>
<p class="calibre1"><span class="speaker">Sabine</span> <span class="regie">(legt
den Arm um Otto)</span>. Komm, Otto, den Herrn Vetter lassen wir
auspoltern. Er hat heute, scheint's, seinen reizbaren Tag. Die
Schuljungen haben ihn wohl geärgert.</p>
<p class="calibre1"><span class="speaker">Nast</span> <span class="regie">(mit
arroganter Heiterkeit)</span>. O nein, schöne Muhme, da irrst
du dich. Ein Schuljungenstreich geniert keinen Weisen. So was stört
meine Götterlaune nicht. <span class="regie">(Sabine mit Otto
ab.)</span></p>
<p class="stage">Agathe, ein schöngewachsenes, etwas
bleichsüchtiges, üppiges Mädchen, tritt durch die Tür an der
Schrankseite. Das hellblonde Haar umrahmt, schlicht gescheitelt,
das ovale, großäugige, süße Gesicht, das einen Zug von Schwermut
hat. Die Bewegungen Agathens sind weich und geräuschlos. Ihr Gang
rhythmisch und wie schwebend. Sie hüllt sich, wärmebedürftig, in
ein Spitzentuch.</p>
<p class="calibre1"><span class="speaker">Agathe</span>. Guten Morgen, Ewald.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Da bist du ja! – Um Gottes
willen, wie siehst du denn aus?</p>
<p class="calibre1"><span class="speaker">Agathe</span> <span class="regie">(an sich
hinuntersehend)</span>. Wie? ist etwa wieder ein Saum gerissen?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Ist dir nicht wohl, mein
gutes Kind?</p>
<p class="calibre1"><span class="speaker">Agathe</span>. Weshalb sollte mir denn
nicht wohl sein, Vetter?</p>
<p class="calibre1"><span class="speaker">Nast</span>. Vetter? Was ist das für ein
Wort?</p>
<p class="calibre1"><span class="speaker">Agathe</span>. Es ist doch ein Wort, das
dir auch zukommt, Ewald.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Nun, Liebe, ich verzichte
darauf. Dafür will ich dich auch nicht Cousine nennen. – Aber sag
mir nur endlich, was mit dir ist!</p>
<p class="calibre1"><span class="speaker">Agathe</span>. Wieso? – Ich weiß dir
darauf nicht zu antworten. –</p>
<p class="calibre1"><span class="speaker">Nast</span>. Du hast geweint! <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page21" title="987/woldemar"></a></p>
<p class="calibre1"><span class="speaker">Agathe</span>. Ich habe durchaus nicht
geweint, lieber Ewald. Und wenn . . . warum sollte ich schließlich
nicht?</p>
<p class="calibre1"><span class="speaker">Nast</span>. – Du siehst, ich fasse mir an
den Kopf! Ich komme noch gar nicht zu mir selber! Was ist denn auf
einmal mit dir passiert?</p>
<p class="calibre1"><span class="speaker">Agathe</span>. Nichts. Gar nichts, Ewald.
Nicht das geringste. Ich bin eben mit Onkel Gustav
spaziert . . .</p>
<p class="calibre1"><span class="speaker">Nast</span>. Und was habt ihr da
miteinander gesprochen?</p>
<p class="calibre1"><span class="speaker">Agathe</span>. Nichts! Sicherlich nichts,
was dich interessiert.</p>
<p class="calibre1"><span class="speaker">Nast</span>. So?! Und du glaubst, so lass'
ich mich abspeisen?</p>
<p class="calibre1"><span class="speaker">Agathe</span>. Ach, Ewald, bitte! Du
peinigst mich. Du mußt mir ein wenig Ruhe lassen.</p>
<p class="calibre1"><span class="speaker">Nast</span>. – Wann hätte ich deine Ruhe
gestört? – Willst du mich jetzt nicht sehen, Agathe, so sage es
nur. – Du hast Anspruch auf jegliche Rücksichtnahme, als Patient
und als Rekonvaleszent.</p>
<p class="calibre1"><span class="speaker">Agathe</span> <span class="regie">(geht
heftig umher)</span>. Ich bin nicht mehr leidend! So laß doch nur
das! Weshalb mußt du es mir denn täglich vorhalten? Ich bin so wie
jeder andere Mensch und verlange durchaus keine größere
Rücksicht.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Der alte Irrtum, die alte
Not! Wenn dir freilich mein Rat irgend etwas gilt und die Zukunft,
der wir entgegeneilen – ich kann nicht anders! es tut mir
leid –, so laß uns, ich bitte dich wieder darum, doch endlich
mit festen Entschlüssen hervortreten! Dieser Zustand martert uns
beide nur.</p>
<p class="calibre1"><span class="speaker">Agathe</span>. – Nun auf einmal wiederum
diese Wendung.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Jawohl, mit vollem
Bewußtsein, Kind. – Ich kann warten, ich bin nicht ungeduldig, auch
an deinem Charakter zweifle ich nicht. Auch daß eure Verhältnisse
glänzende sind, ist ein Umstand, der mich nicht weiter beeinflußt.
Ich bin genügsam und habe mein Auskommen. Nein! Aber wir sind in
der Leute Mund . . . und ich weiß eigentlich nicht, worauf wir noch
warten. – Oder, Agathe, treibst du dein Spiel mit mir?</p>
<p class="calibre1"><span class="speaker">Agathe</span>. Wie kannst du bloß so etwas
denken, Ewald!</p>
<p class="calibre1"><span class="speaker">Nast</span>. Nun gut, ich denke es
eigentlich nicht. Ja, das Gegenteil ist mir durchaus Gewißheit.
Vorwärts! Zögern wir also nicht! – Du schweigst. – Es ist immer das
gleiche Schweigen, das du mir, sooft ich bis jetzt auf diese Sache
gekommen bin, wie eine Mauer entgegenstellst. Ich kann mir dieses
Schweigen nicht ausdeuten. <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page22" title="987/woldemar"></a></p>
<p class="calibre1"><span class="speaker">Agathe</span> <span class="regie">(nach
einigem Stillschweigen)</span>. Ewald, du brauchst eine Frau, die
tüchtig . . . jedenfalls anders ist! Was willst du mit jemand, wie
ich bin, anfangen, der so mit sich selber uneins ist, so untüchtig
und so verkehrt erzogen. Du kannst mir glauben, du kennst mich
nicht.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Du leidest an einer gewissen
Pusillanimität: an sonst nichts! Das ist meine Sache; darauf lasse
ich es ankommen. Hast du nur einige Neigung zu mir, so wollen wir
uns schon darüber hinwegsetzen. Also, beste Agathe, – <span class="regie">(er faßt ihre Hand)</span> – entschließe dich!</p>
<p class="calibre1"><span class="speaker">Agathe</span> <span class="regie">(bewegt
und mit Überwindung)</span>. Nun, Ewald, in einer Zeit, wo sich
wirklich keine Menschenseele auf Erden um mich gekümmert hat, wo
ich körperlich und auch geistig völlig daniederlag, hast du allein
unter allen Menschen dich um mich gekümmert! Du allein nahmst dich
meiner an. Gut also: ich bleibe dir also nichts schuldig. – Du
nimmst mich selbst ja als Ausgleich an. Also sei es! Das übrige
mußt du verantworten: nämlich, wenn es zu deinem Guten nicht ist. –
Jetzt aber . . . um eines ersuch' ich dich noch . . . es ist
jemand . . . Dr. Grünwald ist wieder aufgetaucht . . . ich habe dir
niemals was angedeutet . . . möglicherweise hast du doch etwas
munkeln gehört . . . er darf unter keiner Bedingung heraufkommen!
Jedenfalls werde ich ihn unter keiner Bedingung wiedersehen. – Und
davor mußt du mich schützen, Ewald, daß ich diesen Entschluß etwa
brechen muß.</p>
<p class="calibre1"><span class="speaker">Nast</span>. Wie? Was? – Du kennst mich;
ich werde alles veranlassen. <a class="pcalibre2 pcalibre3 pcalibre1 pcalibre" id="page23" title="987/woldemar"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?7ce2911e